import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  payment: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "payment",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    
    // view user relative
    builder.addCase(Act.PAYMENT_LIST.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.PAYMENT_LIST.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      payment: payload,
    }));
    builder.addCase(Act.PAYMENT_LIST.rejected, (state, action) => ({
      ...state,
      loading: false,
      qrprice: null,
    }));
    // payments details
    builder.addCase(Act.PaymentsDetails.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.PaymentsDetails.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      payment: payload,
    }));
    builder.addCase(Act.PaymentsDetails.rejected, (state, action) => ({
      ...state,
      loading: false,
      payment: null,
    }));
//   // delete Qr price
//    builder.addCase(Act.deleteQrPrice.pending, (state) => {
//       state.loading = true;
//       state.error = null;
//     })
//     builder .addCase(Act.deleteQrPrice.fulfilled, (state, action) => {
//       state.loading = false;
//       state.error = null;

//     })
//     builder.addCase(Act.deleteQrPrice.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.error.message || action.error;
//     });

//     // delete video
//     builder.addCase(Act.deleteVideo.pending, (state) => {
//       state.loading = true;
//       state.error = null;
//     })
//     builder .addCase(Act.deleteVideo.fulfilled, (state, action) => {
//       state.loading = false;
//       state.error = null;

//     })
//     builder.addCase(Act.deleteVideo.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.error.message || action.error;
//     });
//     // arcieve users relatives
//     builder.addCase(Act.ARCHIEV_RELATIVE.pending, (state) => {
//       state.loading = true;
//       state.error = null;
//     })
//     builder .addCase(Act.ARCHIEV_RELATIVE.fulfilled, (state, action) => {
//       state.loading = false;
//       state.error = null;

//     })
//     builder.addCase(Act.ARCHIEV_RELATIVE.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.error.message || action.error;
//     });
     },
});

export default slice;
